import baseAxios from "./BaseApi";

class QualificationApi {
  /**
   * 資格証を検索する
   * @param {Object} params - 検索パラメータ
   * @param {string} params.name - 資格名（前方後方一致）
   * @param {number} params.limit - 取得件数制限
   * @param {number} params.offset - オフセット
   * @returns {Promise} API レスポンス
   */
  async searchQualifications(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.name) queryParams.append('name', params.name);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    return baseAxios.get(`/user/qualifications/search?${queryParams.toString()}`);
  }
}

export default new QualificationApi();
